export enum Networks {
    POLYGON_TEST = 80001,
    POLYGON_MAINNET = 137
}

export const DEFAULD_NETWORK = Networks.POLYGON_TEST;
